import CombinedTitle from "../../../shared/components/title/CombinedTitle";
import PopularSpace from "./PopularSpace.jsx";
import useIsMobile from "shared/hooks/use-is-mobile";
import { useTranslation } from 'react-i18next';

const TestimonialsSection = () => {

    const { t } = useTranslation();
    const isMobile = useIsMobile();

    return (
        <section className="w-full bg-white pt-10 pb-20 px-4 flex flex-col lg:flex-row justify-center items-center">
            <div className="block lg:hidden w-full">
                <PopularSpace />
            </div>
            <div className="w-full max-w-6xl">
                {/* Section Title */}
                <CombinedTitle
                    intro={t('website.testimonials.intro')}
                    title={t('website.testimonials.title')}
                    subtitle={t('website.testimonials.subtitle')}
                />
                {/* Testimonial Cards */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 max-w-6xl mx-auto">
                    {/* Left tall card in large devices, which is just a card in a column for small devices */}
                    <div className="row-span-2 scale-[0.98] transform">
                        {renderCard(testimonials[0], t)}
                    </div>
                    <div className="w-full flex flex-col gap-4">
                        {/* Right top card in large devices, which is also a card in a column for small devices */}
                        <div className="scale-[0.98] transform">
                            {renderCard(testimonials[1], t, isMobile)}
                        </div>
                        {/* Right bottom card in large devices, hidden in small devices */}
                        <div className="hidden lg:grid lg:grid-cols-2 gap-4">
                            <div className="scale-[0.95] transform">
                                {renderCard(testimonials[2], t)}
                            </div>
                            <div className="scale-[0.95] transform">
                                {renderCard(testimonials[3], t)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TestimonialsSection;

const renderCard = (item, t, usePrimarySmallDevice) => {
    return (
        <div
            className={`
                rounded-2xl p-8 border h-full shadow-sm justify-center flex flex-col
                ${(item.dark || usePrimarySmallDevice) ? "bg-lime-700 text-white" : "bg-white border-gray-300 text-gray-800"}
            `}
        >
            {/* Metric */}
            {item.metric && (
                <p className={`text-7xl font-extrabold mb-2`}>{t(`website.testimonials.items.${item.id}.metric`)}</p>
            )}
            {/* Title */}
            {item.title && (
                <p
                    className={`text-lg font-semibold mb-4 text-${(item.dark || usePrimarySmallDevice) ? "white" : "gray-900"}`}
                >
                    {t(`website.testimonials.items.${item.id}.title`)}
                </p>
            )}
            {/* Quote */}
            <div className="flex items-start gap-2 mb-6">
                <p className="leading-relaxed opacity-90">
                    "{t(`website.testimonials.items.${item.id}.quote`)}"
                </p>
            </div>
            {/* Footer */}
            <div className="flex items-center gap-3">
                {/* <img
                    src={item.image || "https://res.cloudinary.com/dorkbt39x/image/upload/v1764117533/francesco-liotti-3HP6_D9hxFY-unsplash_3_cjzsr0.jpg"}
                    alt={item.author}
                    className="w-12 h-12 rounded-full object-cover"
                /> */}
                <div>
                    <p className={`font-semibold text-sm ${(item.dark || usePrimarySmallDevice) ? "text-white" : "text-gray-900"}`}>
                        {t(`website.testimonials.items.${item.id}.author`)}
                    </p>
                    <p className={` text-xs text-gray-500  ${(item.dark || usePrimarySmallDevice) ? "text-white" : "text-gray-900"}`}>{t(`website.testimonials.items.${item.id}.role`)}</p>
                </div>
            </div>

        </div>
    );
};

const testimonials = [
    {
        id: 1,
        metric: "8X",
        title: "Increase in conversion rate",
        quote:
            "Our team often needs a professional place for client discussions and planning. MeetsNWorks gives us a reliable, well-equipped environment where we can meet without the distractions of the office.",
        author: "Tariq Kessy",
        role: "CEO Director, RelNet",
    },
    {
        id: 2,
        metric: "2X",
        title: "Increase in lead generation",
        quote:
            "When we need to bring colleagues and clients together, it helps to have a comfortable and well-prepared space. The rooms make our meetings feel organized and professional.",
        author: "Happiness Egidius",
        role: "CEO, 10kLakes Limited",
    },
    {
        id: 3,
        quote:
            "During busy tax periods, a quiet meeting room helps us focus, review documents, and give clients the attention they deserve.",
        author: "Mariam Rashid",
        role: "Managing Partner, Tax Services",
    },
    {
        id: 4,
        quote:
            "We use the meeting spaces for strategy sessions and discussions that require the whole team to be present. The setting is comfortable, practical, and easy to work in.",
        author: "Ibrahim Peter",
        role: "CEO, Bertina Group of Companies",
        dark: true,
    },
];
